<script>
import { mapState } from 'vuex'
export default {
  name: 'PetRow',
  props: ['pet'],
  computed: {
    ...mapState({
      coupons: state => state.coupons,
    }),
    couponName() {
      const coupon = this.coupons.find(c => c.code == this.pet.couponCode)
      if(coupon) {
        return coupon.name
      }
      return ''
    }
  },
}
</script>

<template>
  <v-row class="petrow px-0">
    <v-col class="px-0" align="left" cols="10">
      '{{ pet.name }}', {{ pet.breed }}, {{ pet.dob }}, <b>{{ pet.plan.name }}</b>
      <v-chip v-if="couponName" class="ml-2" small color="success"><v-icon small class="mr-2">mdi-ticket</v-icon>{{ couponName }}</v-chip>
    </v-col>
    <v-col class="px-0" align="left" cols="2">${{ pet.plan.costPerMonth }}/mo*</v-col>
  </v-row>
</template>

<style lang="scss" scoped>
  .petrow {
    border-bottom: solid 1px #E2E2E2;
  }
</style>
